/**
 * Create an action for when the settings are updated.
 *
 * {
 *     type: SETTINGS_UPDATED,
 *     settings: {
 *         audioOutputDeviceId: string,
 *         avatarURL: string,
 *         cameraDeviceId: string,
 *         displayName: string,
 *         email: string,
 *         localFlipX: boolean,
 *         micDeviceId: string,
 *         serverURL: string,
 *         startAudioOnly: boolean,
 *         startWithAudioMuted: boolean,
 *         startWithVideoMuted: boolean,
 *         startWithReactionsMuted: boolean
 *     }
 * }
 */
export const SETTINGS_UPDATED = 'SETTINGS_UPDATED';
export const INIT_ROOM_SETTINGS = 'INIT_ROOM_SETTINGS';
export const OPEN_MODAL_ADV = 'OPEN_MODAL';
export const UN_MUTED_SET_VOLUME = 'UN_MUTED_SET_VOLUME';
export const UPDATE_VOLUME_STATE = 'UPDATE_VOLUME_STATE';
